import { Result, Spin } from "antd";
import React, { FC } from "react";
import Details from "../../../../components/detailsList";
import LeasingStore from "../../../../contexts/leasingStore";
import _t from "../../../../lang/translate";
import { keyNumbersUrl } from "../../../../services/leasingService";
import { useApi } from "../../../../services/useApi";
import { KeyNumbersType } from "../../../../types/leasingTypes";
import DividerLine from "../../../../components/lineSplit";
import SimpleCard from "../../../../components/simpleCard";

interface SeparatorTitleProps {
  title: string;
}

const SeparatorTitle: FC<SeparatorTitleProps> = ({ title }) => {
  let separator;

  switch (title) {
    case "Resterende måneder":
      separator = (
        <>
          <Details.Title
            className="m-0"
          >
            <DividerLine fluid />
            <h3>{_t("actual_status")}</h3>
          </Details.Title>
        </>
      )
      break;
    case "Kunden egenfinansiering i %":
      separator = (
        <>
          <Details.Title
            className="m-0"
          >
            <DividerLine fluid />
            <h3>{_t("capital_requirements")}</h3>
          </Details.Title>
        </>
      )
      break;
    case "Endelig indtægt":
      separator = (
        <>
          <Details.Title
            className="m-0"
          >
            <DividerLine fluid />
            <h3>{_t("final_key_values")}</h3>
          </Details.Title>
        </>
      )
      break;
    case "Indtægt (Uden moms)":
      separator = (
        <>
          <Details.Title
            className="m-0"
          >
            <h3>{_t("core_earnings")}</h3>
          </Details.Title>
        </>
      )
      break;
    default:
      separator = null;
  }

  return separator;
}

type Bucket = 'income' | 'capital' | 'status' | 'expiration';
const titleMapping: Record<Bucket, string> = {
  capital: _t("capital_requirements"),
  expiration: _t("final_key_values"),
  income: _t("core_earnings"),
  status: _t("actual_status")
}
function divideIntoBuckets(data: KeyNumbersType[]) {
  const bucketTypes: Bucket[] = ['income', 'capital', 'status', 'expiration']
  const buckets: Partial<Record<Bucket, KeyNumbersType[]>> = {}
  let bucketIndex = 0;
  for (const item of data) {
    switch (item.label) {
      case "Indtægt (Uden moms)": bucketIndex = 0; break;
      case "Kunden egenfinansiering i %": bucketIndex = 1; break;
      case "Resterende måneder": bucketIndex = 2; break;
      case "Endelig indtægt": bucketIndex = 3; break;
    }
    const bucketType = bucketTypes[bucketIndex]
    buckets[bucketType] ??= [];
    buckets[bucketType].push(item)
  }
  return buckets
}
const LeasingKeyNumbers: FC = () => {
  const { leasingCase } = LeasingStore.useContainer();
  const [{ data, isLoading, isError }] = useApi<KeyNumbersType[]>(keyNumbersUrl(leasingCase.id), []);

  const buckets = divideIntoBuckets(data)
  return (
    <Spin spinning={isLoading} wrapperClassName="min-height-100">
      {isError && <Result status="error" title={_t("msg.unknown_error")} className="result-small" />}

      {(Object.keys(buckets) as Bucket[]).map((bucket: Bucket, index, arr) => {
        const items = buckets?.[bucket]
        const title = titleMapping[bucket]
        return (
          <SimpleCard key={bucket} className={index < (arr.length - 1) ? "mb-1" : "mb-0"} title={title}>
            <Details className="mb-0" borderLess>
              {items?.map((item) => {
                return (
                  <Details.Item key={item.label} {...item} />
                )
              })}
            </Details>
          </SimpleCard>
        )
      })}
    </Spin>
  );
};

export default LeasingKeyNumbers;
